export default __webpack_public_path__ + "static/media/news140.49fb5586.jpg";